import React from "react";
import { useSelector } from "react-redux";
import { Card, CardBody, Col } from "reactstrap";
//Import images
import DefaultAvatar from "../../../../assets/images/avatar.png";
import {
  dataUrl,
  formatDate,
  getJobLocationById,
  humanReadableSize,
  isEmailVerified,
  toArray,
} from "../../../../helpers/common";
import { ResendverifyEmailLink } from "../../../../api/customer";
import { toast } from "react-toastify";
import { useState } from "react";

const LeftSideContent = () => {
  const { profile } = useSelector((state) => state.customer);
  const [isResending, setIsResending] = useState(false);

  // 🎯 Safe parsing helper — handles both stringified JSON and objects
  const getParsedFields = (fieldData) => {
    if (!fieldData) return {};
    if (typeof fieldData === "object") return fieldData;
    try {
      return JSON.parse(fieldData);
    } catch (e) {
      console.error("Failed to parse additional_fields:", e);
      return {};
    }
  };

  const handleResendEmail = async () => {
    try {
      setIsResending(true);
      const res = await ResendverifyEmailLink();
      toast.success(res?.message || "Verification link sent successfully!");
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to send verification link.",
      );
    } finally {
      setIsResending(false);
    }
  };

  const additional_fields = getParsedFields(profile?.additional_fields);

  const profile_picture = additional_fields?.profile_picture
    ? `https://sdsjobseekers.runasp.net/uploads/profile_image/${additional_fields.profile_picture}`
    : "";

  const resume_url = `${dataUrl}/customers/${additional_fields?.resume}`;
  const cover_letter_url = `${dataUrl}/customers/${additional_fields?.cover_letter}`;

  const handleResumeDownload = () => {
    const fileUrl = profile?.data?.resumeFile
      ? `${process.env.REACT_APP_UPLOAD_URL}/${profile.data.resumeFile}`
      : resume_url;

    const fileName =
      profile?.data?.resumeFile?.split("/").pop() || "resume.pdf";

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getList = (item) => {
    const list = toArray(item, ",");
    return list || [];
  };

  const finalImage = profile?.data?.profileImage
    ? profile.data.profileImage.startsWith("http")
      ? profile.data.profileImage
      : `https://sdsjobseekers.runasp.net/uploads/profile_image/${profile.data.profileImage}`
    : profile_picture || DefaultAvatar;

  const displaySrc = finalImage.startsWith("http")
    ? `${finalImage}?t=${profile?.data?.updatedAt || Date.now()}`
    : finalImage;

  return (
    <React.Fragment>
      <Col lg={4}>
        <Card className="profile-sidebar me-lg-6">
          <CardBody className="">
            <div className="text-center pb-4 border-bottom">
              <img
                src={displaySrc}
                alt="profile pic"
                style={{
                  width: "60px",
                  height: "60px",
                  objectFit: "cover",
                  marginTop: "15px",
                }}
                className="avatar-lg img-thumbnail rounded-circle mb-4"
              />
              <h5 className="mb-0 text-capitalize">
                {profile?.firstName ||
                  profile?.data?.firstName ||
                  additional_fields?.firstName ||
                  "User"}
              </h5>
              <p className="text-muted">
                {profile?.designation ||
                  profile?.data?.designation ||
                  additional_fields?.designation}
              </p>

              <ul className="candidate-detail-social-menu list-inline mb-0">
                {(profile?.facebookUrl ||
                  profile?.data?.facebookUrl ||
                  additional_fields?.facebook_url) && (
                  <li className="list-inline-item">
                    <a
                      href={
                        profile?.facebookUrl ||
                        profile?.data?.facebookUrl ||
                        additional_fields?.facebook_url
                      }
                      target={"_blank"}
                      className="social-link rounded-3 btn-soft-primary"
                      rel="noreferrer"
                    >
                      <i className="uil uil-facebook-f"></i>
                    </a>
                  </li>
                )}
                {(profile?.twitterUrl ||
                  profile?.data?.twitterUrl ||
                  additional_fields?.twitter_url) && (
                  <li className="list-inline-item">
                    <a
                      href={
                        profile?.twitterUrl ||
                        profile?.data?.twitterUrl ||
                        additional_fields?.twitter_url
                      }
                      target={"_blank"}
                      className="social-link rounded-3 btn-soft-info"
                      rel="noreferrer"
                    >
                      <i className="uil uil-instagram-alt"></i>
                    </a>
                  </li>
                )}
                {(profile?.whatsappNumber ||
                  profile?.data?.whatsappNumber ||
                  additional_fields?.whatsapp_number) && (
                  <li className="list-inline-item">
                    <a
                      href={`https://wa.me/${
                        profile?.whatsappNumber ||
                        profile?.data?.whatsappNumber ||
                        additional_fields?.whatsapp_number
                      }`}
                      className="social-link rounded-3 btn-soft-success"
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      <i className="uil uil-whatsapp"></i>
                    </a>
                  </li>
                )}
                {(profile?.linkedinUrl ||
                  profile?.data?.linkedinUrl ||
                  additional_fields?.linkedin_url) && (
                  <li className="list-inline-item">
                    <a
                      href={
                        profile?.linkedinUrl ||
                        profile?.data?.linkedinUrl ||
                        additional_fields?.linkedin_url
                      }
                      target={"_blank"}
                      className="social-link rounded-3 btn-soft-primary"
                      rel="noreferrer"
                    >
                      <i className="uil uil-linkedin-alt"></i>
                    </a>
                  </li>
                )}
              </ul>
            </div>

            <div className="mt-4 border-bottom">
              <h5 className="fs-17 fw-bold mb-3">Personal Info</h5>
              <div className="profile-contact">
                <ul className="list-unstyled mb-3">
                  {(profile?.gender ||
                    profile?.data?.gender ||
                    additional_fields?.gender) && (
                    <li>
                      <div className="d-flex align-items-center">
                        <h6 style={{ marginBottom: 0, marginRight: 10 }}>
                          Gender:
                        </h6>
                        <p className="text-muted mb-0">
                          {profile?.gender ||
                            profile?.data?.gender ||
                            additional_fields?.gender}
                        </p>
                      </div>
                    </li>
                  )}
                  {(profile?.dateOfBirth ||
                    profile?.data?.dateOfBirth ||
                    additional_fields?.date_of_birth) && (
                    <li>
                      <div className="d-flex align-items-center">
                        <h6 style={{ marginBottom: 0, marginRight: 10 }}>
                          Date of Birth:
                        </h6>
                        <p className="text-muted mb-0">
                          {formatDate(
                            profile?.dateOfBirth ||
                              profile?.data?.dateOfBirth ||
                              additional_fields?.date_of_birth,
                          )}
                        </p>
                      </div>
                    </li>
                  )}
                  {(profile?.maritalStatus ||
                    profile?.data?.maritalStatus ||
                    additional_fields?.marital_status) && (
                    <li>
                      <div className="d-flex align-items-center">
                        <h6 style={{ marginBottom: 0, marginRight: 10 }}>
                          Marital Status:
                        </h6>
                        <p className="text-muted mb-0">
                          {profile?.maritalStatus ||
                            profile?.data?.maritalStatus ||
                            additional_fields?.marital_status}
                        </p>
                      </div>
                    </li>
                  )}
                  {(profile?.fatherName ||
                    profile?.data?.fatherName ||
                    additional_fields?.fathers_name) && (
                    <li>
                      <div className="d-flex align-items-center">
                        <h6 style={{ marginBottom: 0, marginRight: 10 }}>
                          Father's Name:
                        </h6>
                        <p className="text-muted mb-0">
                          {profile?.fatherName ||
                            profile?.data?.fatherName ||
                            additional_fields?.fathers_name}
                        </p>
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            </div>

            <div className="mt-4">
              <h5 className="fs-17 fw-bold mb-3">Contacts</h5>
              <div className="profile-contact">
                <ul className="list-unstyled mb-0">
                  {profile?.email && (
                    <li>
                      <div className="d-flex align-items-center flex-wrap gap-2">
                        <h6 className="mb-0 me-2">Email:</h6>

                        <a
                          href={`mailto:${profile?.email}`}
                          className="text-muted text-break me-2"
                        >
                          {profile?.email}
                        </a>

                        {profile?.data?.isEmailVerfied === 1 ? (
                          <span className="badge bg-success">
                            <i className="mdi mdi-check-circle me-1"></i>
                            Verified
                          </span>
                        ) : (
                          <div className="d-flex align-items-center gap-2">
                            <span className="badge bg-warning text-dark">
                              <i className="mdi mdi-alert-circle-outline me-1"></i>
                              Not Verified
                            </span>

                            <button
                              type="button"
                              className="btn btn-sm btn-outline-primary py-0 px-2"
                              style={{ fontSize: "12px" }}
                              onClick={handleResendEmail}
                              disabled={isResending}
                            >
                              {isResending ? (
                                <>
                                  <span
                                    className="spinner-border spinner-border-sm me-1"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                  Sending...
                                </>
                              ) : (
                                <>
                                  <i className="mdi mdi-send me-1"></i>
                                  Resend Link
                                </>
                              )}
                            </button>
                          </div>
                        )}
                      </div>

                      {profile?.data?.isEmailVerfied !== 1 && (
                        <small className="text-warning d-block mt-1">
                          Verification link has been sent to your email. Please
                          check your inbox.
                        </small>
                      )}
                    </li>
                  )}
                  {(profile?.phoneNumber || profile?.mobile_number) && (
                    <li className="mt-2">
                      <div className="d-flex align-items-center">
                        <h6 style={{ marginBottom: 0, marginRight: 10 }}>
                          Phone:
                        </h6>
                        <a
                          href={`tel:${
                            profile?.phoneNumber || profile?.mobile_number
                          }`}
                          className="text-muted mb-0"
                        >
                          {profile?.phoneNumber || profile?.mobile_number}
                        </a>
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </CardBody>

          {(profile?.skills ||
            additional_fields?.skills ||
            additional_fields?.languages_known) && (
            <CardBody className="p-4 border-top">
              {(profile?.skills || additional_fields?.skills) && (
                <div className="border-bottom pb-4 mb-4">
                  <h6 className="fs-17 fw-semibold mb-3">
                    Professional Skills
                  </h6>
                  <div className="d-flex flex-wrap align-items-start gap-1">
                    {getList(profile?.skills || additional_fields?.skills)?.map(
                      (item, index) => (
                        <span
                          key={"skill-" + index}
                          className="badge fs-13 bg-soft-success mt-2"
                          style={{
                            whiteSpace: "break-spaces",
                            lineHeight: "1.4",
                          }}
                        >
                          {item}
                        </span>
                      ),
                    )}
                  </div>
                </div>
              )}
            </CardBody>
          )}
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default LeftSideContent;
